module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-beaches-457cedc808de091d8bd64e5f6f34786f.svg";